module.exports = __webpack_public_path__ + "media/bell-song.0092b112.mp3";